import { FC } from 'react';
import { Overview } from './tabs/Overview/Overview';
import { DecumulationTab } from './Decumulation.types';

export const DECUMULATION_TAB_MAP: Record<DecumulationTab, FC<any>> = {
  [DecumulationTab.Overview]: Overview,
};
